import { useRef } from "react";
import { languageSetterList } from "../../Constants";

import { getDaysLabel, getHoursLabel } from "../../../scripts/scripts";

export default function ExpireDateComponent({ expireDate, language }) {
  let expireStatus = "";
  let ariaLabel = "";

  const entryTime = useRef(new Date());

  const [year, month, day, hours, minutes, seconds] = expireDate.match(/\d+/g);

  const getDaysLabel = (days, language) => {
    if (language === "en") {
      return days === 1 ? "day" : "days";
    }

    if (language === "ru") {
      const lastTwo = days % 100;
      const last = days % 10;

      if (lastTwo >= 11 && lastTwo <= 14) {
        return "дней";
      }

      if (last === 1) {
        return "день";
      }

      if (last >= 2 && last <= 4) {
        return "дня";
      }

      return "дней";
    }

    if (language === "ua") {
      const lastTwo = days % 100;
      const last = days % 10;

      if (lastTwo >= 11 && lastTwo <= 14) {
        return "днів";
      }

      if (last === 1) {
        return "день";
      }

      if (last >= 2 && last <= 4) {
        return "дні";
      }

      return "днів";
    }

    return "";
  };

  const getHoursLabel = (hours, language) => {
    if (language === "en") {
      return hours === 1 ? "hour" : "hours";
    }

    if (language === "ru") {
      const lastTwo = hours % 100;
      const last = hours % 10;

      if (lastTwo >= 11 && lastTwo <= 14) {
        return "часов";
      }

      if (last === 1) {
        return "час";
      }

      if (last >= 2 && last <= 4) {
        return "часа";
      }

      return "часов";
    }

    if (language === "ua") {
      const lastTwo = hours % 100;
      const last = hours % 10;

      if (lastTwo >= 11 && lastTwo <= 14) {
        return "годин";
      }

      if (last === 1) {
        return "година";
      }

      if (last >= 2 && last <= 4) {
        return "години";
      }

      return "годин";
    }

    return "";
  };

  function daysLeft() {
    const expirationDate = new Date(year, month - 1, day, hours, minutes, seconds);

    const difference = expirationDate - entryTime.current;

    const days = Math.floor(difference / (1000 * 60 * 60 * 24));

    const hoursLeft = (difference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60);

    if (days >= 31) {
      expireStatus = "normal";
    } else if (days > 0) {
      expireStatus = "attention";
    } else if (hoursLeft > 0) {
      expireStatus = "attention";
    } else {
      expireStatus = "expired";
    }

    if (days > 1) {
      ariaLabel = `${days} ${getDaysLabel(days, language)} ${languageSetterList.timeLeft[language]}`;
    } else if (days === 1) {
      ariaLabel = languageSetterList.expireTomorrow[language];
    } else if (hoursLeft > 0) {
      if (hoursLeft < 1) {
        ariaLabel = `${languageSetterList.lessThanHour[language]}`;
      } else {
        ariaLabel = `${hoursLeft} ${getHoursLabel(hoursLeft, language)}`;
      }
    } else {
      ariaLabel = languageSetterList.activationExpired[language];
    }
  }

  daysLeft();

  return (
    <div className={`expire-date expire-date--${expireStatus}`} title={ariaLabel}>
      <p className="expire-date__value">{`${day}-${month}-${year} ${hours}:${minutes}:${seconds}`}</p>
    </div>
  );
}
